import React, { useEffect, useState } from "react";
import CommonTable from "../sharedComponents/CommonTable";
import { Box, Button, ListItemIcon, MenuItem, Typography } from "@mui/material";
import Add from "@mui/icons-material/Add";
import { CommonDialog } from "../sharedComponents/CommonDialog";
import { getActionGroups, getDeleteActionGroup, } from "../../service/ApiService";
import { useLocation } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationPopup from "../sharedComponents/ConfirmationPopup";
import EditIcon from "@mui/icons-material/Edit";
import AlertMsg from "../sharedComponents/Alert";


const GroupsView: React.FC = () => {
  const location = useLocation();
  const [actionGroupsList, setActionGroupsList] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false)
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertData, setAlertData] = useState<any>();

  useEffect(() => {
    getactionGroupsList();
  }, []);

  const getactionGroupsList = () => {
    setIsLoading(true);
    const flowId: any = new URLSearchParams(location.search).get("flowId");
    getActionGroups(flowId)
      .then((response: any) => {
        setActionGroupsList([]);
        if (response && response.length > 0) {
          setActionGroupsList(response);
        }
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      })
      .catch((error: any) => {
        setIsLoading(false);
      });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = (isSubmitted: boolean) => {
    setOpen(false);
    setSelectedRowData(null);
    if (isSubmitted) {
      getactionGroupsList();
    }
  };

  const handleEditItem = (rowData: any, type:string) => {
    let tempObj: any = { ...rowData };
    setSelectedRowData(tempObj);
    if(type === "edit"){
      setOpen(true);
    }
    else if(type === "delete"){
      OpenConfirmationPop();
    }
  };

  const columns: any = [
    {
      accessorKey: "id",
      header: "ID",
      size: 50,
    },
    {
      accessorKey: "title",
      header: "Title",
      size: 350,
    },
    {
      accessorKey: "infoText",
      header: "Info Text",
      accessorFn: (row: any) => (
        <div title={row.infoText} className="truncate cursor-pointer">
          {row.infoText}
        </div>
      ),
    },
  ];

  const renderCustomToolbar = () => {
    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">Groups</Typography>
        <Button variant="outlined" onClick={handleClickOpen}>
          <Add /> Add new group
        </Button>
      </Box>
    );
  };

  const renderRowActionMenuItems = (props: any) => {
    return [
      <MenuItem
        key={0}
        onClick={() => {
          handleEditItem(props.row.original, 'edit');
          props.closeMenu();
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <EditIcon />
        </ListItemIcon>
        Edit
      </MenuItem>,
      <MenuItem
        key={1}
        onClick={() => {
          handleEditItem(props.row.original, 'delete');
          props.closeMenu();
        }}
        sx={{ m: 0 }}
      >
        <ListItemIcon>
          <DeleteIcon  />
        </ListItemIcon>
        Delete
      </MenuItem>,
    ];
  };
  const ConfirmationPopClose = () => {
    setOpenConfirmation(false);
  };
  
  const OpenConfirmationPop = () => {
    setOpenConfirmation(true);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  }

  const DeleteActionGroup = () => {
    getDeleteActionGroup(selectedRowData?.id)
      .then((response: any) => {
        setOpenSnackbar(true);
        if (response.success) {
          setAlertData({ "type": true, "msg": `The action group has been deleted successfully` });
          getactionGroupsList();
        } else {
          setAlertData({ "type": false, "msg": response.errorMessage ?? `The action group deletion was unsuccessful` });
        }
        ConfirmationPopClose();
      })
      .catch((error: any) => {
        console.log('error', error)
      });
  };

  return (
    <div className="container mx-auto">
      <CommonTable
        columnsList={columns}
        dataList={actionGroupsList || []}
        isLoading={isLoading}
        renderCustomToolbar={renderCustomToolbar}
        renderRowActionMenuItems={renderRowActionMenuItems}
        enableRowActions={true}
        positionActionsColumn="last"
      />
      <CommonDialog
        isOpen={open}
        title={`${selectedRowData?.id ? "Edit groups" : "Add new groups"}`}
        actionType="upsertGroups"
        dataToSet={selectedRowData}
        handleClose={handleClickClose}
        dialogwidth="50%"
      />
      <ConfirmationPopup
        isOpen={openConfirmation}
        description="Are you sure you want to delete the group?"
        handleClose={ConfirmationPopClose}
        handleConfirm={DeleteActionGroup}
      />
      <AlertMsg openSnackbar={openSnackbar} alertdata={alertData} onClose={handleSnackbarClose} />
    </div>
  );
};

export default GroupsView;

















